module.exports = __webpack_public_path__ + "img/realized.4944a735.png";